<div class="custom-snackbar">
  @if (data.type === 'warning') {
  <img
    src="images/notification2.svg"
    alt="error"
    class="snackbar-icon error-icon"
  />
  } @else {
  <mat-icon
    class="snackbar-icon"
    [ngClass]="{
      success: data.type === 'success',
      error: data.type === 'error',
      info: data.type === 'info'
    }"
  >
    {{ icon }}
  </mat-icon>
  }

  <div class="snackbar-message">
    @if (isString(message)) {
    <span>{{ message }}</span>
    } @else { @for (msg of message; track msg) {
    <span>{{ msg?.description }}<br /></span>
    } }
  </div>
  <button class="snackbar-close" (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
